import React, { Component } from 'react';
import asyncRoute from '../../helpers/hoc/asyncRoute';
import routes from '../../routes';
import { constants } from '../../constants/configuration';
import './HelpAndSupport.scss';

const Header = asyncRoute(() => import('../../components/Header'));

class HelpAndSupport extends Component {
  onBackClick = () => {
    const { history } = this.props;
    history.goBack();
  };

  render() {
    return (
      <>
        <Header onBackClick={this.onBackClick} identifier={routes.containers.helpAndSupport} />
        <div className="help-and-support">
          <div className="help-and-support_description">
            <p>{constants.helpAndSupport.description}</p>
            {/* <p>{constants.helpAndSupport.phone}</p> */}
            <p>
              {constants.helpAndSupport.email}{' '}
              <a href="mailto:admin@fudr.in">{constants.helpAndSupport.mail}</a>
            </p>
            <p>{constants.helpAndSupport.time}</p>
          </div>
        </div>
      </>
    );
  }
}

export default HelpAndSupport;
